<ng-container *ngIf="['submit', 'reassign', 'evaluate', 'assignees', 'assign', 'addUserToWorkgroup'].includes(action)">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="assignment-form" fxLayout="column" fxLayoutAlign="start stretch">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div fxLayout="column" fxLayoutAlign="center start" class="form-container">
									<ng-container *ngIf="action === 'addUserToWorkgroup' && newUsers?.length">
										<div fxLayout="row" fxLayoutGap="10px">
											<ng-container *ngFor="let user of newUsers">
												<app-chips type="legend" (title)="searchPeopleDetail(user)"
													[data]="{imageSrc: user?.profilePicURL, title: user.name}">
												</app-chips>
											</ng-container>
										</div>
									</ng-container>
									<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="formObjectReader($event)"></app-form-group>

									<ng-container *ngIf="action === 'assign' && !showNote">
										<div class="card-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
											<p class="hyperlink" (click)="showFields('note')">
												{{locale.translate('add_note')}}</p>
										</div>
									</ng-container>

									<app-form-group [fieldList]="completeDateFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="formObjectReader($event)"></app-form-group>

								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<app-alert id="assignCard"></app-alert>
									<div fxLayout="row" fxLayoutAlign="center center">
										<ng-container *ngIf="['submit', 'reassign', 'evaluate'].includes(action)">
											<button [disabled]="submitDisable" mat-stroked-button class="submit-btn" type="button"
												(click)="update()">{{locale.translate('submit')}}</button>
										</ng-container>
										<ng-container *ngIf="['addUserToWorkgroup'].includes(action)">
											<button [disabled]="submitDisable" mat-stroked-button class="submit-btn" type="button"
												(click)="update()">{{locale.translate('add')}}</button>
										</ng-container>
										<ng-container *ngIf="['assign'].includes(action)">
											<button [disabled]="submitDisable" mat-stroked-button class="submit-btn" type="button"
												(click)="update()">{{locale.translate('assign')}}</button>
										</ng-container>
										<ng-container *ngIf="['addUserToWorkgroup'].includes(action)">
											<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
												class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
										</ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="['assignResource'].includes(action)">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="assignment-form" fxLayout="column" fxLayoutAlign="start stretch">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div fxLayout="column" fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="[resource]" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="resourceFormObjectReader($event)">
									</app-form-group>

									<ng-container *ngIf="embedData">
										<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px"
											fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px" class="embed-view">
											<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px"
												fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px">
												<ng-container *ngIf="embedData?.image">
													<div fxFlex="0 0 150px" fxFlex.xs="100%">
														<div class="thumbnail">
															<img [src]="embedData?.image" alt="">
														</div>
													</div>
												</ng-container>
												<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
													<ng-container *ngIf="embedData?.title">
														<a class="link-title linkable" [attr.href]="embedData?.link" target="_blank">
															{{embedData?.title}}
														</a>
													</ng-container>
													<ng-container *ngIf="embedData?.link">
														<a class="embed-url linkable" [attr.href]="embedData?.link" target="_blank">
															{{embedData?.link}}
														</a>
													</ng-container>
													<ng-container *ngIf="embedData?.description">
														<div class="embed-desc">{{embedData?.description}}</div>
													</ng-container>
												</div>
											</div>
											<div class="btn-holder"
												[ngClass]="{'fx-row fx-end-start' : !detectDevice?.resolutionState$?.value?.xs, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
												<button class="remove-btn" mat-icon-button type="button" (click)="removeEmbed()">
													<mat-icon>clear</mat-icon>
												</button>
											</div>
										</div>
									</ng-container>

									<ng-container *ngIf="resourceData && !embedData">
										<div class="updates-content fx-column fx-start-stretch">

											<div class="card-block fx-column fx-start-stretch">
												<ng-container *ngIf="!['playlist', 'answer','internalEvent',
													'externalEvent'].includes(resourceData?.resourceTypeID?.key)">
													<app-content-image-card [record]="resourceData" [type]="'minimal'">
													</app-content-image-card>
												</ng-container>
												<ng-container *ngIf="resourceData?.resourceTypeID?.key === 'playlist'">
													<app-playlist-card [data]="resourceData" [type]="'minimal'">
													</app-playlist-card>
												</ng-container>
												<ng-container *ngIf="resourceData?.resourceTypeID?.key === 'answer'">
													<app-question-card [type]="'minimal'" [data]="resourceData">
													</app-question-card>
												</ng-container>
												<ng-container
													*ngIf="['internalEvent', 'externalEvent'].includes(resourceData?.resourceTypeID?.key)">
													<app-event-card [type]="'minimal'" [data]="resourceData">
													</app-event-card>
												</ng-container>
											</div>
										</div>
										<!-- <app-content-image-card [type]="'minimal'" [record]="resourceData">
										</app-content-image-card> -->
										<!-- <div class="resource-search-card" fxLayout="row" fxLayoutAlign="start stretch">
											<ng-container *ngIf="![null, undefined, ''].includes(resourceData?.resource?.thumbnail)">
												<div fxFlex="0 0 90px" class="resource-thumbnail">
													<div class="thumbnail">
														<img [src]="resourceData?.resource?.thumbnail"
															(error)="gfService.setErrorImage($event, 'broken_image')">
														<ng-container *ngIf="resourceData?.resourceFormat">
															<div class="img-overlay" fxLayout="row" fxLayoutAlign="center center">
																<div class="format-icon" fxLayout="row" fxLayoutAlign="center center">
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'video'">
																		<mat-icon svgIcon="video_camera">
																		</mat-icon>
																	</ng-container>
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'audio'">
																		<mat-icon svgIcon="audio_headphone">
																		</mat-icon>
																	</ng-container>
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'page'">
																		<mat-icon svgIcon="pages">
																		</mat-icon>
																	</ng-container>
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'link'">
																		<mat-icon svgIcon="external_link">
																		</mat-icon>
																	</ng-container>
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'document'">
																		<mat-icon svgIcon="document">
																		</mat-icon>
																	</ng-container>
																	<ng-container *ngIf="resourceData?.resourceFormat?.key === 'image'">
																		<mat-icon svgIcon="image_collection"></mat-icon>
																	</ng-container>
																</div>
															</div>
														</ng-container>
													</div>
												</div>
											</ng-container>
											<div class="search-card-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayoutGap="4px">
												<div fxLayout="row" fxLayoutAlign="start start">
													<div class="sub-txt-patch">
														{{resourceData?.resourceTypeID?.caption}}</div>
												</div>
												<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
													<p class="card-title" fxFlex="1 1" fxFlex.xs="auto">
														{{resourceData.title}}</p>
												</div>
											</div>
										</div> -->
									</ng-container>

									<app-form-group [fieldList]="activityFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="activityFormObjectReader($event)"></app-form-group>

									<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="formObjectReader($event)"></app-form-group>

									<ng-container *ngIf="!showNote">
										<div class="card-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
											<p class="hyperlink" (click)="showFields('note')">
												{{locale.translate('add_note')}}</p>
										</div>
									</ng-container>

									<app-form-group [fieldList]="completeDateFields" [formObjectData]="formObjectData" [config]="config"
										fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
										fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
										(formObject)="formObjectReader($event)"></app-form-group>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<app-alert id="assignCard"></app-alert>
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" mat-stroked-button class="submit-btn" type="button"
											(click)="update()">{{locale.translate('assign')}}</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>
